import App from 'features/App';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import ReduxInactivityTimeout from 'shared/modules/ReduxInactivityTimeout';
import theme from 'shared/themes/storis';
import { buildStore, history } from 'redux/store';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";

// configure a redux-connected router and provide the material-ui theme to components
const routes = () => {
	const store = buildStore();

	// add inactivity timer and allow it to dispatch actions
	ReduxInactivityTimeout.configure(store);

	return (
		<Router history={history}>
			<MuiThemeProvider theme={theme}>
				<Provider store={store}>
					<ConnectedRouter store={store} history={history}>
						<App />
					</ConnectedRouter>
				</Provider>
			</MuiThemeProvider>
		</Router>		
	);
};

export default routes;
